'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dictionary = require('./classes/Dictionary');

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _Dictionary2.default({
  GLOBAL: 'Global',
  US: 'US',
  NORTH_AMERICA: 'North America',
  LATIN_AMERICA: 'Latin America',
  THE_CARIBBEAN: 'The Caribbean',
  EUROPE: 'Europe',
  ASIA_PACIFIC: 'Asia-Pacific',
  CHINA: 'China',
  MENA: 'MENA',
  AFRICA: 'Africa',
  OTHER: 'Others'
});